import clsx from 'clsx';
import React from 'react';

import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';

import ActionButton from '../ActionButton/ActionButton';

type DeleteDraftButtonProps = {
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled: boolean;
};

const DeleteDraftButton = ({ onClick = () => {}, isDisabled = false }: DeleteDraftButtonProps) => (
  <ActionButton
    className={clsx(
      'tw-m-0 tw-p-[2px]',
      'tw-text-cfo-red-300 tw-bg-[#FEF0F0]',
      'tw-rounded-[25px]',
      'hover:enabled:tw-bg-cfo-red-400 hover:enabled:tw-text-white'
    )}
    buttonType={'style_unset'}
    onClick={onClick}
    disabled={isDisabled}
  >
    <Icon icon={ICONS.close} className={clsx('tw-text-[12px]')} />
  </ActionButton>
);

export default DeleteDraftButton;
